import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import get from 'lodash.get'
import { withRouter } from 'react-router-dom'

import AdminTemplate from '../../../templates/Admin/Admin'
import { logout } from '../../../../actions/users'

const testAuthenticate = props => {
  const { user } = props
  const status = localStorage.getItem('jwt')

  if (!status) {
    props.history.push('/')
  }
}

class Admin extends Component {
  constructor (props) {
    super(props)

    testAuthenticate(props)
  }

  componentWillUpdate (nextProps) {
    testAuthenticate(nextProps)
  }

  componentDidUpdate (nextProps) {
    testAuthenticate(nextProps)
  }

  render () {
    return (
      <AdminTemplate {...this.props} />
    )
  }
}

const mapStateToProps = state =>
  Object.assign({
    user: get(state, 'users.data', {})
  })

const mapDispatchToProps = dispatch => bindActionCreators({
  logout
}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Admin))



// WEBPACK FOOTER //
// ./src/components/pages/Admin/Admin/Admin.container.js